export default function HeroBanner() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative w-full mt-16">

      {/* Imagem 100% visível, sem cortes, em qualquer tamanho de tela */}
      <div className="relative w-full">
        <img
          src="https://storage.readdy-site.link/project_files/ca8f3ce7-75b3-4a89-a83a-a57d16fa0d98/7cbffc4c-d3a9-488e-b559-5f65056c1dd8_M1H-PROFESSORES-1920X1080--barra-1.png?v=ff575352de0a22aa802b743fdec6e7a5"
          alt="Mude1Hábito Experience 3ª Edição"
          className="w-full h-auto block"
        />

        {/* Botão flutuante sobre o banner — apenas desktop */}
        <div className="hidden sm:flex absolute bottom-5 left-0 right-0 justify-center px-4">
          <span
            className="bg-gray-400 text-white font-semibold text-sm px-6 py-2.5 rounded-full cursor-not-allowed whitespace-nowrap flex items-center gap-1.5 shadow-md"
          >
            <i className="ri-ticket-2-line" />
            Inscrições encerradas
          </span>
        </div>

        {/* Seta de scroll */}
        <button
          onClick={() => scrollTo("cronograma")}
          className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-colors cursor-pointer animate-bounce"
        >
          <i className="ri-arrow-down-line text-xl sm:text-2xl" />
        </button>
      </div>

      {/* Botão abaixo da imagem — apenas mobile */}
      <div className="flex sm:hidden justify-center px-4 py-3 bg-white">
        <span
          className="bg-gray-400 text-white font-semibold text-sm px-5 py-2 rounded-full cursor-not-allowed whitespace-nowrap flex items-center gap-1.5 w-full justify-center"
        >
          <i className="ri-ticket-2-line" />
          Inscrições encerradas
        </span>
      </div>

    </section>
  );
}